import type { StateWithSinatra } from '../types';

export const selectAuth = (state: StateWithSinatra) => state.sinatra.auth;
export const selectLoadingSaml = (state: StateWithSinatra) =>
  state.sinatra.auth.loadingSAML;
